/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceDataDto { 
    type: DeviceDataDto.TypeEnum;
    unit?: string;
    amount?: number;
    rawAmount?: number;
}
export namespace DeviceDataDto {
    export const TypeEnum = {
        MagneticField: 'MAGNETIC_FIELD',
        Acceleration: 'ACCELERATION',
        Position: 'POSITION',
        Activity: 'ACTIVITY',
        Proximity: 'PROXIMITY',
        MortalityImplant: 'MORTALITY_IMPLANT',
        VaginalImplant: 'VAGINAL_IMPLANT',
        Separation: 'SEPARATION',
        DebugLogs: 'DEBUG_LOGS',
        CollarLogs: 'COLLAR_LOGS',
        Mortality: 'MORTALITY'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


